export default __webpack_public_path__ + "static/media/closeImg.30c54004.svg";